<template>
	<ListItem
		is-recipient
		:custom-text="text"
		info
	/>
</template>

<script>
import ListItem from "@/vue/communication/conversation/message/ListItem.vue";
import {get} from "@/helper/communication/conversation/message/CollaborationText";

export default {
	components: {ListItem},
	props: {
		message: {
			type: Object,
			required: true
		}
	},

	computed: {
		text ()
		{
			return get(this.message);
		}
	}
}
</script>
